export const wotcApplicationsKey = 'wotcApplications';
export const wotcSurveyDataKey = 'wotcSurveyDataKey';
export const wotcDocumentsKey = 'wotcDocuments';
export const errorMessage = 'Sorry, something went wrong';
